<template>
  <div class="pv-overlay" :class="{ 'pv-pier': site === 'rbxpier' }" @click.self="close">
    <div class="pv-modal privileged-login">
      <button class="pv-modal__close" @click="close" aria-label="Закрыть">×</button>
      <h2 class="pv-modal__title">Режим изменений</h2>
      <p class="pv-modal__subtitle">
        Открывает изменение баланса и отмену заказов. Ключ хранится только в этой вкладке: закроете её или не будете
        ничего делать 30 минут — режим выключится.
      </p>

      <div class="pv-section">
        <span class="pv-label">Проект</span>
        <div class="pv-segmented">
          <button v-for="item in sites" :key="item" :class="{ 'is-active': site === item }" @click="selectSite(item)">
            {{ siteNames[item] }}
            <span v-if="$store.state.privilegedSites[item]" class="privileged-login__on">● вкл</span>
          </button>
        </div>
      </div>

      <template v-if="!$store.state.privilegedSites[site]">
        <div class="pv-section">
          <label class="pv-label" for="privileged-key">Ключ доступа {{ siteNames[site] }}</label>
          <div class="privileged-login__key">
            <input
              id="privileged-key"
              ref="keyInput"
              v-model.trim="key"
              class="pv-input pv-mono"
              :type="showKey ? 'text' : 'password'"
              autocomplete="off"
              placeholder="Вставьте ключ"
              @keydown.enter="enable"
            />
            <button class="pv-btn pv-btn--ghost pv-btn--small" @click="showKey = !showKey">
              {{ showKey ? "Скрыть" : "Показать" }}
            </button>
          </div>
          <p class="pv-hint">
            Ключ проверяется при первой операции. Если он неверный, режим выключится и попросит ввести его заново.
          </p>
        </div>
        <div class="pv-actions">
          <button class="pv-btn pv-btn--primary" :disabled="!key" @click="enable">
            Включить для {{ siteNames[site] }}
          </button>
        </div>
      </template>

      <template v-else>
        <div class="pv-alert pv-alert--success">Режим изменений для {{ siteNames[site] }} включён.</div>
        <div class="pv-actions">
          <button class="pv-btn pv-btn--ghost" @click="disable(site)">Выключить для {{ siteNames[site] }}</button>
          <button class="pv-btn pv-btn--danger" @click="disableAll">Выключить всё</button>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import "@/scss/_privileged.scss";
import "./privilegedLogin.scss";

import { SITES, SITE_NAMES, setKey, clearKey, clearAll } from "@/utils/privileged";

export default {
  name: "PrivilegedLogin",
  data() {
    const current = this.$store.state.toggleSite;
    return {
      sites: SITES,
      siteNames: SITE_NAMES,
      site: SITES.includes(current) ? current : "rbxtree",
      key: "",
      showKey: false
    };
  },
  methods: {
    selectSite(site) {
      this.site = site;
      this.key = "";
      this.focusInput();
    },
    focusInput() {
      this.$nextTick(() => this.$refs.keyInput && this.$refs.keyInput.focus());
    },
    enable() {
      if (!this.key) return;
      setKey(this.site, this.key);
      this.key = "";
      this.close();
    },
    disable(site) {
      clearKey(site);
      this.focusInput();
    },
    disableAll() {
      clearAll();
      this.close();
    },
    close() {
      this.$store.state.isOpenPrivilegedLogin = false;
    }
  },
  mounted() {
    this.focusInput();
  }
};
</script>
